module.exports = function(locale, preview, filters) {
  return `
fragment ComponentWidthFragment on ComponentWidth {
  sys {
    id
  }
  name
  desktopComponentWidth
  smartphoneComponentWidth
  tabletComponentWidth
}

fragment PageMetaDataFragment on PageMetaData {
  sys {
    id
  }
  __typename
  pageTitle
  metaTitle
  metaDescription
  metaKeywords
  openGraphPageTitle
  openGraphDescription
}

fragment HeadingFragment on HeadingTypes {
  sys {
    id
  }
  styles
  headingName
  componentWidth {
    ... on ComponentWidth {
      ...ComponentWidthFragment
    }
  }
  heading
  __typename
}
fragment ImageSetFragment on ImageSet {
  sys {
    id
  }
  __typename
  name
  altText
  styles
  desktopImage {
    title
    url
    fileName
    contentType
  }
  tabletImage {
    title
    url
    fileName
    contentType
  }
  smartphoneImage {
    title
    url
    contentType
    fileName
  }
  componentWidth {
    ... on ComponentWidth {
      ...ComponentWidthFragment
    }
  }
}
fragment CardFragment on Callout {
  sys {
    id
  }
  __typename
  name
  styles
  variant
  componentWidth {
    ... on ComponentWidth {
      ...ComponentWidthFragment
    }
  }
  image {
    __typename
    ...on Image{
      altText
    tooltip
    image {
      title
      url
      fileName
    }
    }
    ...on ImageSet{
      ...ImageSetFragment
    }
  }
  title
  subTitle
  text
  supportingText
  callToActionsCollection(limit: 3) {
    ... on CalloutCallToActionsCollection {
      items {
       
        ... on LinkButton {
          ...LinkButtonFragment
        }
        ... on ImageButton {
          ...ImageButtonFragment
        }
      }
    }
  }
}



fragment LinkButtonFragment on LinkButton {
  __typename
  sys {
    id
  }
  name
  styles
  link
  linkText
  tooltip
  gaEventClass
  variant
  target
  referencePageCollection(limit: 1) {
    ... on LinkButtonReferencePageCollection {
      items {
        ... on Product {
          sys {
            id
          }
          gtin
          slug
        }
      }
    }
  }
  componentWidth {
    ... on ComponentWidth {
      ...ComponentWidthFragment
    }
  }
}

fragment ImageButtonFragment on ImageButton {
  sys {
    id
  }
  name
  styles
  altText
  linkText
  link
  tooltip
  gaEventClass
  target
  componentWidth {
    ... on ComponentWidth {
      ...ComponentWidthFragment
    }
  }
  image {
    url
    fileName
    contentType
    title
  }
  __typename
}

{
  articleListCollection(limit: 1, locale: "${locale}", preview: ${preview}, where: {slug: "${filters.slug}"}) {
    items {
      slug
      pageMetadata {
        ... on PageMetaData {
          ...PageMetaDataFragment
        }
      }
       pageContentCollection {
        items {
          sys {
            id
          }
        }
      }

      facet{
        title
        sys{
          id
        }
        name
        slug
        
      }
      facetCategory {
        sys {
          id
        }
        title
        uniqueId
      }
      relatedProductsCollection(limit:5){
        items{
          sys{
            id
          }
          productName
          productShortName
          shortDescription
          slug
          productCategoryType
          breadcrumbTitle
          heroImage{
            sys{id}
            title
            contentType
            fileName
            url
          }
          ratingAndReviewId  
        }
      }
      navigation {
        sys {
          id
        }
        title
        menuSlotsCollection(limit: 50) {
          items {
            title
            name
            link
            menuItemsCollection(limit: 10) {
              items {
                menuText
                menuLink
              }
            }
          }
        }
      }
      promosCollection {
        items {
          __typename
          ... on HeadingTypes {
            ...HeadingFragment
            componentWidth {
              ...ComponentWidthFragment
            }
          }
          ... on Callout {
            ...CardFragment
            variant
          }
        }
      }
    }
  }
    articleCollection(locale: "${locale}", preview: ${preview}){
      items{
        sys{id}
        name
        slug
        title
        addedOn
        shortDescription
        facetCollection(limit:20){
          items{
            sys{id}
            name
            title
            facetCategory{
              title
              uniqueId
            }
          }
        }
        heroImage{
          url
        }
      }
    }
  facetCategoryCollection(limit: 2, order: order_ASC , locale: "${locale}", preview: ${preview}) {
    items {
      sys {
        id
      }
      order
      title
      uniqueId
      facetCollection(limit:20) {
        items {
          title
          sys {
            id
          }
          name
          slug
        }
      }
    }
  }
}
`;
};
